import axios, {AxiosResponse, Method} from "axios"
import qs from "qs"
import Cookies from "js-cookie"
import {noticeController} from "./NoticeController"


export interface ActionAnswer<T = any> {
    data: T
    status: string
    errors?: { message: string, fixPath?: string, trace: string, line: string, file: string }[]
}

export interface Pagination<T = any> {
    page: number,
    pageCount: number,
    count: number,
    content: T
}

declare var backend_url: string;

export default class RequestHelper {


    public static send(method: Method, moduleAndAction: string, data: any = undefined): Promise<AxiosResponse<ActionAnswer>> {
        const url = backend_url + "ozon/?app=ozon&module=";
        let queryString = ""
        if (method === "get" || method === "delete") {
            if (data) {
                queryString = "&" + qs.stringify(data)
                data = undefined
            }
        } else {
            data["_csrf"] = Cookies.get("_csrf")
        }
        return axios({
            method,
            url: url + moduleAndAction + queryString,
            data: qs.stringify(data),
            headers: {'cache-control': 'no-cache', 'pragma':'no-cache'},
            withCredentials: true
        }).then((response: AxiosResponse<ActionAnswer>) => {
            if (response.data.status === "ok" && response.data.errors === undefined) {
                return response
            } else {
                if (response.data.errors) {
                    const errorsMessage = [...noticeController.errors]
                    for (const error of response.data.errors) {
                        console.error(error)
                        errorsMessage.push({message: error.message, fixPath: error.fixPath})
                    }
                    noticeController.errors = errorsMessage
                }

                return response
            }
        })
    }

    public static getActionUrl(data: { action: string, [key: string]: any }) {
        return "?" + qs.stringify(data)
    }

    public static getParams() {
        return qs.parse(window.location.search)
    }

}

export interface CommandData {
    command: string,
    type: string,
    last_start_time?: string
}